import OfferBadge from 'components/Common/OfferBadge'
import Pane from 'components/Common/Pane'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'

export const Main = styled(Pane)`
  display: grid;
  position: relative;
  z-index: 0;

  ${mediaQueryUp.sm} {
    grid-template-rows: 1fr;
    grid-template-columns: 50% 1fr;
  }

  ${mediaQueryUp.md} {
    grid-template-rows: 1fr;
    grid-template-columns: 40% 1fr;
  }
`

export const MainImageSegment = styled.div`
  position: relative;
  height: 100%;

  min-height: ${rem(230)};
  ${mediaQueryUp.sm} {
    min-height: ${rem(360)};
  }
`

export const DetailSegment = styled.div`
  position: relative;
  padding: ${rem(20)} ${rem(24)};
  width: 100%;
  ${mediaQueryUp.md} {
    justify-content: space-between;
    display: grid;
    grid-template-columns: 60% 1fr;
    min-height: ${rem(360)};
  }
`

export const StyledCSSBreakpoint = styled(CSSBreakpoint)`
  position: absolute;
  top: 0;
  left: ${rem(16)};
  right: 0;
`

export const OfferOverlayContainer = styled.div`
  position: absolute;
  top: ${rem(12)};
  left: ${rem(12)};
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & > * + * {
    margin-top: ${rem(8)};
  }
`

export const StyledOfferBadge = styled(OfferBadge)`
  position: absolute;
  top: ${rem(16)};
  right: ${rem(16)};
`

export const ViewBundleOfferWrapper = styled.div`
  margin-top: ${rem(16)};
  grid-column: 1 / 3;
`
